
import { defineComponent, PropType } from 'vue'
import SettingPanel from '@/views/fuzoku-meisai/SettingPanel.vue'
import { ResponseSettingItem } from '@/repositories/keiei-joho/data'
import { SonekiKeisanUiItem } from '@/views/keiei-joho/data'

export default defineComponent({
  components: {
    SettingPanel
  },
  props: {
    item: {
      type: Object as PropType<SonekiKeisanUiItem>,
      required: true
    }
  },
  emits: {
    changeInput: (item: SonekiKeisanUiItem) => true
  },
  setup (props, { emit }) {
    const onUpdateKmk = (panelName: string, item: ResponseSettingItem) => {
      const propItem: SonekiKeisanUiItem = props.item
      propItem.item.setting = item
      emit('changeInput', propItem)
    }

    return {
      onUpdateKmk
    }
  }
})
